import { Apollo } from 'src/gql/generated';

export function useDocumentStatus(documentId: UUID): Apollo.DocumentStatus | null {
  const { data } = Apollo.useGetDocumentStatusQuery({ variables: { documentId } });

  return data?.document?.status || null;
}
